import { Box, Typography } from "@mui/material";
export default function DetailView({ title, fields }) {
  return (
    <Box component="section">
      {title && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <Box
        component="dl"
        sx={{
          m: 0,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "minmax(120px, 1fr) 2fr" },
          gap: 1.5,
        }}
      >
        {fields.map(({ label, value }) => (
          <Box key={label} sx={{ display: "contents" }}>
            <Typography component="dt" color="text.secondary">
              {label}
            </Typography>
            <Typography component="dd" sx={{ m: 0, overflowWrap: "anywhere" }}>
              {value ?? "Not provided"}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
